/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Atelier_HeadlineInputs */

const en_atelier_headline = /** @type {(inputs: Atelier_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where the collection is born.`)
};

/**
* | output |
* | --- |
* | "Where the collection is born." |
*
* @param {Atelier_HeadlineInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const atelier_headline = /** @type {((inputs?: Atelier_HeadlineInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Atelier_HeadlineInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_atelier_headline(inputs)
});